import { createMutationHook, createQueryHook } from "../factory";

const transfersKeys = {
  all: ["transfers"] as const,
  lists: () => [...transfersKeys.all, "list"] as const,
  list: <T>(filters: T) => [...transfersKeys.lists(), filters] as const,
};

const preflightReportTransferKeys = {
  all: ["preflightReportTransfer"] as const,
  details: <T>(input: T) =>
    [...preflightReportTransferKeys.all, "detail", input] as const,
};

export const reports = {
  getAllTransfers: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.reports.getAllTransfers,
    queryKeyFn: transfersKeys.list,
  }),
  preflightReportTransfer: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.reports.preflightReportTransfer,
    queryKeyFn: preflightReportTransferKeys.details,
  }),
  sendClaimReportsToClient: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.reports.sendClaimReportsToClient,
    mutationKey: ["reports", "sendClaimReportsToClient"],
  }),
  versionReport: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.reports.versionReport,
    mutationKey: ["reports", "versionReport"],
  }),
};
